// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"32e83d55","234":"25b3afd5","455":"21a3c46a","482":"9404f788","544":"17713e9b","708":"270bba97"}[chunkId] + ".chunk.js";
};